import { render, staticRenderFns } from "./SharePopupV2.vue?vue&type=template&id=70ac5378&scoped=true"
import script from "./SharePopupV2.vue?vue&type=script&lang=js"
export * from "./SharePopupV2.vue?vue&type=script&lang=js"
import style0 from "./SharePopupV2.vue?vue&type=style&index=0&id=70ac5378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac5378",
  null
  
)

export default component.exports